import { faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons';

import { ContentCard } from 'apps/dashboard/shared/scripts/components';
import { Icon, LabelValue } from 'apps/shared/scripts/components';
import { CardFragment } from 'apps/shared/scripts/graphql/fragments/CardFragment.generated';
import { formatDateYear } from 'apps/shared/scripts/utils';

import {
  bodyClassName,
  headerClassName,
  headingClassName,
  iconClassName,
  iconWrapperClassName,
} from './styles';

interface Props {
  card: CardFragment;
}

const CardSummary = ({ card }: Props) => {
  return (
    <ContentCard>
      <div className={headerClassName}>
        <div className={iconWrapperClassName}>
          <Icon className={iconClassName} fa={faEnvelopeOpenText} />
        </div>
        <h2 className={headingClassName}>Summary</h2>
      </div>
      <div className={bodyClassName}>
        <LabelValue label="Recipient" value={card.recipientName} />
        <LabelValue label="Title" value={card.headline} />
        {card.senderName && (
          <LabelValue label="Sender" value={card.senderName} />
        )}
        <LabelValue label="Posts" value={card.postCount} />
        <LabelValue label="Created on" value={formatDateYear(card.createdAt)} />
      </div>
    </ContentCard>
  );
};

CardSummary.displayName = 'CardSummary';

export default CardSummary;
